import * as React from 'react';
import { Icon } from 'semantic-ui-react';
import { InfoIconPopup } from './popup';
import { OperationItem } from 'types/operation-item';
import { LanguageCode } from 'types/tenants/language-code';

import './styles.css';

export interface Props {
  language: LanguageCode;
  operationItem: OperationItem;
}

export class InfoIconCell extends React.Component<Props> {
  render() {
    const icon = <Icon name="info circle" className="info-icon" />;

    return (
      <InfoIconPopup operationItem={this.props.operationItem} trigger={icon} language={this.props.language} />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/cells/info-icon/component.tsx